export function generateRandom() {
  let number = (Math.random() * (999999 - 100000) + 100000).toString().replace('.', '');
  return number;
}
